import { jsx as _jsx } from "react/jsx-runtime";
import { Button as BaseButton } from "sprout-ui-dom/dist/Button";
import { ArrowDropDown } from "sprout-ui-icons";
import { media } from "sprout-ui-theme";
import styled, { css } from "styled-components";
const Button = styled(BaseButton)`
  ${({ $for  })=>$for === "desktop" && css`
      ${media.down("medium")} {
        display: none;
      }

      width: 40px;
      height: 40px;

      position: absolute;
      top: 4px;
      left: -44px;
    `}

  ${({ $for  })=>$for === "mobile" && css`
      margin: -8px 0 -8px -16px;

      ${media.up("medium")} {
        display: none;
      }
    `}
`;
const StyledArrowDropDown = styled(ArrowDropDown)`
  transition: transform 0.2s ease;

  ${({ $expand  })=>!$expand && `transform: rotate(-90deg);`}
`;
const TopicPageSectionExpandButton = (props)=>{
    const { onClick , isExpanded , variant  } = props;
    return /*#__PURE__*/ _jsx(Button, {
        variant: "circle",
        onClick: onClick,
        $for: variant,
        children: /*#__PURE__*/ _jsx(StyledArrowDropDown, {
            $expand: isExpanded
        })
    });
};
export default TopicPageSectionExpandButton;
